import { useState, useEffect, useMemo } from 'react';
import { Line } from "react-chartjs-2"; 


import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";

import clienteAxios from 'config/axios'
import { useT } from 'i18n';

function currencyFormat(num) {
  return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + ' USDT'
}


const Grafica = (props) => { 

  const { t } = useT();

  
  



const [chartData, setChartData ] = useState({});
    
  const chart = (canvas) => {
    

    let userMontos = [];
    let userFechas = [];

    // let montos = currencyFormat(userMontos);
    // let fechas = currencyFormat(userFechas);

    
    

    clienteAxios
      .post("/api/client/investments/grafica")
      .then(res => {
        
        // console.log(res.data.data[0].amount);
        // console.log(res.data.data);
        // console.log(res.data.label);

        // console.log(res);

        for (const dataObj of res.data.data) {


          userMontos.push(dataObj.amount);
        //   format(dataObj.amount)
          
        }

        for (const dataObj of res.data.label) {
            
            userFechas.push(dataObj.fecha);
          }

        //   console.log(userFechas, userMontos);
        setChartData(
                
                    {
                        labels:userFechas,
                        datasets: [

                            {
                                label: "",
                                fill: true,
                                backgroundColor: "rgba(255,255,255,0)",
                                borderColor: "#e3a82b",
                                borderWidth: 2,
                                borderDash: [],
                                borderDashOffset: 0.0,
                                pointBackgroundColor: "#e3a82b",
                                pointBorderColor: "rgba(255,255,255,0)",
                                pointHoverBackgroundColor: "#e3a82b",
                                pointBorderWidth: 20,
                                pointHoverRadius: 4,
                                pointHoverBorderWidth: 15,
                                pointRadius: 4,
                                data: userMontos,
                                
                              }    
                        ]
                    }
        )



      })
      .catch(err => {
        console.log(err);
      });
    
  };



    
  // la leyenda se traduce al dibujar para que cambie con el idioma
  const datos = useMemo(() => (chartData.datasets
    ? { ...chartData, datasets: chartData.datasets.map((d) => ({ ...d, label: t('grafica.leyenda') })) }
    : chartData), [chartData, t]);

  useEffect(() => {
    const timer = setTimeout(chart, 700);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, []);



    



    


    return (
        <Card className="card-chart card-panther-blu-grafica">
        <CardHeader>
          <Row>
            <Col className="text-left" sm="6">
              <h5 >{t('grafica.sub')}</h5>
              <CardTitle tag="h2">{t('grafica.titulo')}</CardTitle>
            </Col>
            
          </Row>
        </CardHeader>
        <CardBody>
          <div className="chart-area">
          <Line
          data={datos}
          options={{
            maintainAspectRatio: false,
                legend: {
                    display: false
                },
                tooltips: {
                    backgroundColor: "#f5f5f5",
                    titleFontColor: "#333",
                    bodyFontColor: "#666",
                    bodySpacing: 4,
                    xPadding: 12,
                    mode: "nearest",
                    intersect: 0,
                    position: "nearest"
                },
                responsive: true,
            scales: {
                yAxes: [
                  {
                    barPercentage: 1.6,
                    gridLines: {
                      drawBorder: false,
                      color: "rgba(255,255,255,0.04)",
                      zeroLineColor: "transparent"
                    },
                    ticks: {
                      suggestedMin: 60,
                      suggestedMax: 125,
                      padding: 20,
                      fontColor: "#6b7383"
                    }
                  }
                ],
                xAxes: [
                  {
                    barPercentage: 1.6,
                    gridLines: {
                      drawBorder: false,
                      color: "rgba(255,255,255,0.04)",
                      zeroLineColor: "transparent"
                    },
                    ticks: {
                      padding: 20,
                      fontColor: "#6b7383"
                    }
                  }
                ]
              }
          }}
        />
          </div>
        </CardBody>
      </Card>



      );
}
 
export default Grafica;